// tslint:disable

import { getBaseURL } from "../Utilities/Site";

// Third-party dependency that we should probably work on removing.
declare var Uri: any;

type ParamsObject = { [key: string]: any };

type AjaxURLFunction = (actionName: string, paramsObject?: ParamsObject) => string;

//#region Helper Function
function _getFullUrl(uriString: string, paramsObject: ParamsObject) {
    var uriString = getBaseURL() + uriString;
    var uri: Uri = null;
    if (paramsObject) {
        //Do we have params?
        var firstDecode = null;
        var secondDecode = null;
        var encodedParams = $.param(paramsObject, true).replace(/\+/g, "%20"); //MVC hates the + for spaces

        try {
            firstDecode = decodeURIComponent(encodedParams);
            secondDecode = decodeURIComponent(firstDecode);
        } catch (e) {
            secondDecode = firstDecode; //If there are special characters, and you try and do a secondDecode decodeURIComponent will throw an exception. If that happens we know the URL is not already encoded.
        }

        //Prevent double encoding
        if (firstDecode != secondDecode) {
            //Now we know that paramsObject is already encoded don't use results from $.params(...)
            uri = new Uri(uriString);
            $.each(paramsObject, function(index: string, value) {
                uri.addQueryParam(index, value.replace ? value.replace(/\+/g, "%20") : value); //Add all the params to the uri object, in this case don't encode because it was already encoded! However, ensure + is changed to %20 because MVC hates + for spaces
            });
        } else uri = new Uri(uriString + "?" + encodedParams); //The params must be encoded once, so use this encoding first!
    } else uri = new Uri(uriString); //We don't have any params. Simple case!

    var returnUrl = uri.toString();

    return returnUrl;
}
//#endregion

export const API: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `API/v1/${actionName}`;
    return _getFullUrl(strURI, paramsObject);
};
export const Avatar: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `Avatar/${actionName}`;
    return _getFullUrl(strURI, paramsObject);
};
export const RestAPIClasses: AjaxURLFunction = function(actionPathAndName, paramsObject) {
    var strURI = `API/v1/classes/${actionPathAndName}`;
    return _getFullUrl(strURI, paramsObject);
};
export const RestAPICommand: AjaxURLFunction = function(actionPathAndName, paramsObject) {
    var strURI = `API/v1/commands/${actionPathAndName}`;
    return _getFullUrl(strURI, paramsObject);
};
export const RestPrivateAPI: AjaxURLFunction = function(actionPathAndName, paramsObject) {
    var strURI = `PrivateAPI/${actionPathAndName}`;
    return _getFullUrl(strURI, paramsObject);
};
export const FlexUI: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `FlexUI/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};
export const BulkCreateTask: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `BulkCreateTask/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};
export const Persistence: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `Persistence/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};
export const ContainerComponent: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `ContainerComponent/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};

export const LinkedAsset: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `LinkedAsset/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};

export const Home: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `Home/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};

export const Administration: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `Administration/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};

export const LayoutManager: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `LayoutManager/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};

export const Structure: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `Structure/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};

export const AutomationManager: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `AutomationManager/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};

export const AssetConditionManager: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `AssetConditionManager/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};

export const ScenarioBuilder: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `ScenarioBuilder/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};

export const ResourceEstimates: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `ResourceEstimates/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};

export const ScenarioBuilderPrint: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `ScenarioBuilderPrint/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};

export const Map: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `Map/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};

export const Timesheet: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `Timesheet/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};

export const Account: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `Account/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};

export const Summary: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `Summary/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};

export const Report: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `Report/${actionName}/`;

    if (actionName == "" || actionName == undefined) {
        strURI = `Report/`;
    }

    return _getFullUrl(strURI, paramsObject);
};

export const Attachments: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `Attachments/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};

export const Images: AjaxURLFunction = function(imagePath, paramsObject) {
    var strURI = `Images/${imagePath}/`;
    return _getFullUrl(strURI, paramsObject).replace(/\/$/, ""); //Remove trailing slash for images, otherwise MVC get's upset.
};
export const Requests: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `Requests/${actionName}`;
    return _getFullUrl(strURI, paramsObject);
};
export const InternalRequest: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `InternalRequest/${actionName}`;
    return _getFullUrl(strURI, paramsObject);
};
export const ErrorLog: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `ErrorLog/${actionName}`;
    return _getFullUrl(strURI, paramsObject);
};
export const Inspection: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `Inspection/${actionName}`;
    return _getFullUrl(strURI, paramsObject);
};
export const Library: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `Library/${actionName}`;
    return _getFullUrl(strURI, paramsObject);
};
export const Model: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `Model/${actionName}`;
    return _getFullUrl(strURI, paramsObject);
};
export const Tasks: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `Tasks/${actionName}`;
    return _getFullUrl(strURI, paramsObject);
};
export const Import: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `Import/${actionName}`;
    return _getFullUrl(strURI, paramsObject);
};
export const Unsubscribe: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `Unsubscribe/${actionName}`;
    return _getFullUrl(strURI, paramsObject);
};
export const ImportExport: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `ImportExport/${actionName}`;
    return _getFullUrl(strURI, paramsObject);
};
export const BuildURI = function(
    controllerName: string,
    actionName: string,
    paramsObject: ParamsObject
) {
    var strURI = `${controllerName}/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};
export const AssetAdministration: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `AssetAdministration/${actionName}`;
    return _getFullUrl(strURI, paramsObject);
};
export const AdvancedFilter: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `AdvancedFilter/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};
export const SyncGIS: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `SyncGis/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};
export const OAuth: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `OAuth/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};
export const RecordsetFilter: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `RecordsetFilter/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};
export const Materials: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `Materials/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};
export const MaterialLocation: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `MaterialLocation/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};
export const MaterialOrders: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `MaterialOrders/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};
export const Calendar: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `Calendar/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};
export const Search: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `Search/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};
export const ScheduledProcessLog: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `ScheduledProcessLog/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};
export const JULIE: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `JULIEIntegration/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};
export const Eight11: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `Eight11Integration/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};
export const RunAnIntegration: AjaxURLFunction = function (actionName, paramsObject) {
    var strURI = `RunAnIntegration/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};
export const RESTConnect: AjaxURLFunction = function (actionName, paramsObject) {
    var strURI = `RESTConnectIntegration/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};
export const Dev: AjaxURLFunction = function(actionName, paramsObject) {
    var strURI = `Dev/${actionName}/`;
    return _getFullUrl(strURI, paramsObject);
};
